/* External dependencies */
import { Div, Modal, Text } from 'atomize';
import React from 'react';

/* Local dependencies */
import './Popup.scss';

interface PopupProps {
  children: React.ReactNode;
  maxWidth?: string;
  minWidth?: string;
  title: React.ReactChild;
  dataTestId?: string;
  onClose?: () => void;
}

export default function Popup(props: PopupProps) {
  const {
    title,
    children,
    maxWidth = '400px',
    minWidth = 'auto',
    dataTestId,
    onClose,
  } = props;

  return (
    <Modal
      align="center"
      onClose={onClose}
      rounded="sm"
      w="auto"
      maxW={maxWidth}
      minW={minWidth}
      p="none"
      isOpen={true}
      className="popup"
      data-testid={dataTestId}
    >
      <Text
        tag="h1"
        textAlign="left"
        textSize={headerSize}
        textColor={headerColor}
        p={{ x: '1.5rem', y: '1rem' }}
      >
        {title}
      </Text>
      <Div border="1px solid" borderColor="border_color">
        {children}
      </Div>
    </Modal>
  );
}

const headerColor = '#151A30';
const headerSize = '18px';
